module.exports = __webpack_public_path__ + "img/theme15.f9610e82.png";